import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';
import { AuthorizationRequestType } from '../../core/api/clients';
import { IncidentReportDataProvider } from '../../core/context/IncidentReportDataContext';
import { IncidentFieldOptionsProvider } from '../../core/context/IncidentEventFieldOptions';

function IncidentFormLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Admin;
  if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  } else if (action === 'view') {
    requestType = AuthorizationRequestType.View;
  }

  return (
    <div>
      <IncidentReportDataProvider incidentReportId={_toInteger(formId)} role={requestType}>
        <IncidentFieldOptionsProvider>
          <Outlet />
        </IncidentFieldOptionsProvider>
      </IncidentReportDataProvider>
    </div>
  );
}

export default IncidentFormLayout;
